export default "__VITE_ASSET__WhvMeYDA__"